import { API, graphqlOperation } from "aws-amplify";
import handleError from "../../errorHandler";
import { GET_ACTIVE_COURSE_INFO, GET_ACTIVE_COURSE_FAILURE, GET_ACTIVE_COURSE_SUCCESS, TRIGGER_TOAST } from "../constants";
import { GetCurrentCourseDetails } from "../../queries";
import { useSelector } from "react-redux";

const getStoreActiveCourseInfo = (userId: String, licenseId: String, productId: number, uuId: String, course: number) => {
  return async (dispatch: any) => {
    let parsedCourseDetails;
    dispatch({ type: GET_ACTIVE_COURSE_INFO });
    if (!!sessionStorage.getItem("isDemoUser")) {
      const dummyData = require("../../data/MockData/getCurrentCourseDetails.json");
      parsedCourseDetails = dummyData.data.getCurrentCourseDetails ? JSON.parse(dummyData.data.getCurrentCourseDetails) : null;
      dispatch({ type: GET_ACTIVE_COURSE_SUCCESS, payload: { data: parsedCourseDetails } });

    }
    else {
      const data = API.graphql(graphqlOperation(GetCurrentCourseDetails(userId, licenseId, productId, uuId, course))) as Promise<any>;
      await data
        .then((activeCourseData: any) => {
          if (activeCourseData && activeCourseData.data && activeCourseData.data.getCurrentCourseDetails) {
            parsedCourseDetails = activeCourseData.data.getCurrentCourseDetails ? JSON.parse(activeCourseData.data.getCurrentCourseDetails) : null;
            dispatch({ type: GET_ACTIVE_COURSE_SUCCESS, payload: { data: parsedCourseDetails } });
          }
        })
        .catch((err: any) => {
          // handleError(err);
          dispatch({ type: GET_ACTIVE_COURSE_FAILURE });
          dispatch({
            type: TRIGGER_TOAST,
            payload: {
              shouldShow: true,
              severity: 'error',
              transMessage: "message_errorDefault"
            },
          });
        });
    }
  };
};

export default {
  getStoreActiveCourseInfo,
};
